// ----------------------------------------------------------------------
// <copyright file="Izenda.StaticDashboardDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

! function () {
  var m = require('mobx');
  var constants = require('logic/data/Izenda.DashboardConstants');
  var convertToNumeralFormat = require('share/utils/Izenda.ConvertToNumeralFormat');

  function StaticDashboardDetail(data) {

    var props = {
      id: null,
      name: '',
      type: null,
      previewRecord: 0,
      advancedMode: false,
      allowNulls: false,
      isDistinct: false,
      categoryId: null,
      categoryName: null,
      subCategoryId: null,
      subCategoryName: null,
      tenantId: null,
      description: null,
      createdBy: null,
      createdDate: null,
      modifiedBy: null,
      version: 0,
      numberOfView: 0,
      renderingTime: 0,
      owner: null,
      lastViewed: null,
      state: 0,
      modified: null,
      dateTimeNow: null,
      isShowDetail: false,
      accessPriority: null,
      movable: false,
      deletable: false,
      copyable: false,

      isEmpty: function () {
        return this.id === constants.EMPTY_GUID;
      },
      renderingTimeInSeconds: function() {
        return convertToNumeralFormat('0.00', this.renderingTime / 1000) + ' s';
      }
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate information.
   * @param  {Object} data
   */
  StaticDashboardDetail.prototype.populateData = m.action(function (data) {
    data = data || {};
    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.previewRecord = data.previewRecord;
    this.advancedMode = data.advancedMode;
    this.allowNulls = data.allowNulls;
    this.isDistinct = data.isDistinct;
    this.categoryId = data.categoryId;
    this.categoryName = data.categoryName;
    this.subCategoryId = data.subCategoryId;
    this.subCategoryName = data.subCategoryName;
    this.tenantId = data.tenantId;
    this.description = data.description;
    this.createdBy = data.createdBy;
    this.createdDate = data.createdDate;
    this.modifiedBy = data.modifiedBy;
    this.version = data.version;
    this.numberOfView = data.numberOfView;
    this.renderingTime = data.renderingTime;
    this.owner = data.owner;
    this.lastViewed = data.lastViewed;
    this.state = data.state;
    this.modified = data.modified;
    this.dateTimeNow = data.dateTimeNow;
    this.isShowDetail = data.isShowDetail || false;
    this.accessPriority = data.accessPriority;
    this.created = data.created;
    this.isGlobal = data.isGlobal;
    this.deletable = data.deletable;
    this.copyable = data.copyable;
    this.movable = data.movable;
  });

  /**
   * Update show/hide status
   * @param  {Boolean} state
   */
  StaticDashboardDetail.prototype.setStateExpanded = function (state) {
    this.isShowDetail = state;
  };

  /**
   * Update name
   * @param  {String} name
   */
  StaticDashboardDetail.prototype.setDashboardName = function (name) {
    this.name = name;
  };

  /**
   * check if this field will be highlighted or not
   * @param {Object} searchType
   * @param {Object} field
   * @returns {Promise}
   */
  StaticDashboardDetail.prototype.isNotHighLight = function (searchType, field) {
    return searchType !== constants.SEARCH_CRITERIA[0].value &&
      searchType !== field;
  };

  /**
   * Set edit mode
   * @param {boolean} isEditMode
   */
  StaticDashboardDetail.prototype.setEditMode = function (isEditMode) {
    this.isEditMode = isEditMode;
  };

  module.exports = StaticDashboardDetail;
}();


// WEBPACK FOOTER //
// ./ui/logic/models/Dashboard/Izenda.StaticDashboardDetail.js